<div class="row w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Assurance mobile</div>
</div>
<div class="bold-text">L’Assurance mobile couvre :</div>
<div>Tous les mobiles de moins de deux ans, <span class="prixtel-color">neufs ou reconditionnés,</span> contre le vol,
    la casse et l’oxydation pour <span class="prixtel-color">6€/mois.</span></div>
<div>Et si vous changez de téléphone, <span class="prixtel-color">le nouveau est automatiquement assuré.</span></div>
<div class="custom-control custom-checkbox">
    <input type="checkbox" class="custom-control-input" name="confirmation" value="1" [(ngModel)]="isChecked"
           id="defaultUnchecked"/>
    <label class="custom-control-label" for="defaultUnchecked">
        Je certifie avoir pris connaissance de la <a target="_blank" href="{{ environment.data.insuranceNotice }}">notice
        d’information</a>.
    </label>
    @if (error) {
        <small class="form-text error-message">Ce champ est obligatoire</small>
    }
</div>
<div class="row w-100 pt-3 text-center">
    <div class="col-12 w-100 cta_container">
        <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
        <button type="button" class="cta_btn level_2 column" (click)="confirmation()">Valider<span></span></button>
    </div>
</div>
